import { LogicContext } from '@/logic/main/types';
import { promotionsModel } from '@/model/promotions';
import Location from '@/ports-frontend/Location';
import { ViewMode } from '@/ports-frontend/Promotions';

const promotionsViewModePerScreen = {
  small: 'mobile',
  medium: 'desktop',
  wide: 'desktop',
};

export const initializePromotions = async (context: LogicContext) => {
  try {
    if (context.previousPageArray) await stopPromotions();

    await promotionsModel.startPromotionsFlow(
      promotionsViewModePerScreen[context.currentScreenSize] as ViewMode
    );

    return { location: await Location.get() };
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const stopPromotions = async () => {
  try {
    await promotionsModel.stopPromotionsFlow();
  } catch (err) {
    console.log(err);
    throw err;
  }
};
